'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeProcess = exports.addProcess = exports.REMOVE_PROCESS = exports.ADD_PROCESS = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = reducer;
exports.newProcess = newProcess;
exports.delProcess = delProcess;
exports.watchForProcesses = watchForProcesses;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _auth = require('./auth');

var _GenericSettings = require('./GenericSettings');

var _templates = require('./templates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(newProcess),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(delProcess),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchForProcesses);

var ADD_PROCESS = exports.ADD_PROCESS = 'tq-plus-admin/process-queue/ADD_PROCESS';
var REMOVE_PROCESS = exports.REMOVE_PROCESS = 'tq-plus-admin/process-queue/REMOVE_PROCESS';

var initialState = [];

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case ADD_PROCESS:
      {
        var process = action.process,
            isUnique = action.isUnique;


        if (isUnique && state.includes(process)) return state;

        return [].concat((0, _toConsumableArray3.default)(state), [process]);
      }

    case REMOVE_PROCESS:
      {
        var _process = action.process;

        var processIndex = state.indexOf(_process);

        if (processIndex === -1) return state;

        return [].concat((0, _toConsumableArray3.default)(state.slice(0, processIndex)), (0, _toConsumableArray3.default)(state.slice(processIndex + 1)));
      }

    default:
      return state;
  }
}

/* ACTIONS
 * ---------------------------------------------------------------------------------------------- */
var addProcess = exports.addProcess = function addProcess(process) {
  var isUnique = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return { type: ADD_PROCESS, process: process, isUnique: isUnique };
};
var removeProcess = exports.removeProcess = function removeProcess(process) {
  return { type: REMOVE_PROCESS, process: process };
};

/* SAGAS
 * ---------------------------------------------------------------------------------------------- */
function newProcess(process) {
  return _regenerator2.default.wrap(function newProcess$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(addProcess(process));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function delProcess(process) {
  return _regenerator2.default.wrap(function delProcess$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(removeProcess(process));

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/* WATCHERS
* ---------------------------------------------------------------------------------------------- */
var createFetchProcessSagaWatcher = function createFetchProcessSagaWatcher(entity) {
  return [(0, _reduxSaga.takeEvery)(entity.REQUEST, newProcess, entity.BASE), (0, _reduxSaga.takeEvery)(entity.SUCCESS, delProcess, entity.BASE), (0, _reduxSaga.takeEvery)(entity.FAILURE, delProcess, entity.BASE)];
};

function watchForProcesses() {
  return _regenerator2.default.wrap(function watchForProcesses$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return [].concat((0, _toConsumableArray3.default)(createFetchProcessSagaWatcher(_templates.SAVE_TEMPLATE_TYPES)), (0, _toConsumableArray3.default)(createFetchProcessSagaWatcher(_GenericSettings.SAVE_GENERICSETTINGS_TYPES)), (0, _toConsumableArray3.default)(createFetchProcessSagaWatcher(_templates.SAVE_TEMPLATESETTINGS_TYPES)), (0, _toConsumableArray3.default)(createFetchProcessSagaWatcher(_GenericSettings.GET_GENERICSETTINGS_TYPES)), (0, _toConsumableArray3.default)(createFetchProcessSagaWatcher(_GenericSettings.GET_STORAGEOPTIONS_TYPES)), (0, _toConsumableArray3.default)(createFetchProcessSagaWatcher(_templates.GET_TEMPLATES_TYPES)), (0, _toConsumableArray3.default)(createFetchProcessSagaWatcher(_templates.GET_TEMPLATE_TYPES)), (0, _toConsumableArray3.default)(createFetchProcessSagaWatcher(_auth.LOGIN)), (0, _toConsumableArray3.default)(createFetchProcessSagaWatcher(_auth.LOGOUT)));

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/processesQueue.js
// module id = 1660
// module chunks = 0